import React from 'react';
import { motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/7PcxuhXi4yub9rJu45JEFY/1000121922.jpg', 'https://cdn.magicpatterns.com/uploads/kvF2ogornPw2SoMGtL9QQe/1000121908.jpg', 'https://cdn.magicpatterns.com/uploads/qrv98h14R1Vz3gQpzcDPpa/1000121827.jpg', 'https://cdn.magicpatterns.com/uploads/9JFDjjo36WSzsfJjJK5iZm/1000121914.jpg', 'https://cdn.magicpatterns.com/uploads/mFkxvTRtg3wQAUL1PoF49S/1000121916.jpg', 'https://cdn.magicpatterns.com/uploads/kaN5oWoUMH36dXtPtUBcTZ/1000121918.jpg'];
export function Gallery() {
  return <section className="py-24 px-6 bg-charcoal-900" data-id="element-14">
      <div className="container mx-auto max-w-6xl" data-id="element-15">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-serif text-cream" data-id="element-17">
            Nuestras manos{' '}
            <span className="text-gold-400 italic" data-id="element-18">hablan por nosotros.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-19">
          {images.map((src, index) => <motion.div key={index} className="relative aspect-square overflow-hidden rounded-sm bg-charcoal-800 group cursor-pointer" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-20">
              <img src={src} alt={`MA Barber Studio transformation ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" data-id="element-21" />
              <div className="absolute inset-0 bg-charcoal-900/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-22" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}